import { Card, Input, DatePicker, Form, Radio, Checkbox, Button } from "antd";
import { Printer, Save } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function TabCustomerInfo() {
    const { t } = useTranslation();
    return (
        <Card>

            {/* Thông tin khách hàng */}

            <div className="font-semibold mb-4 text-000000e0">
                {t('skin_care.customer_info')}
            </div>

            <Form layout="vertical">

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                    <Form.Item label={t('skin_care.full_name')}>
                        <Input />
                    </Form.Item>

                    <Form.Item label={t('skin_care.gender')}>
                        <Radio.Group>
                            <Radio value="male">{t('skin_care.male')}</Radio>
                            <Radio value="female">{t('skin_care.female')}</Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item label={t('skin_care.dob')}>
                        <DatePicker className="w-full" />
                    </Form.Item>

                    <Form.Item label={t('skin_care.phone')}>
                        <Input />
                    </Form.Item>

                </div>

                <Form.Item label={t('skin_care.address')}>
                    <Input />
                </Form.Item>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                    <Form.Item label={t('skin_care.current_job')}>
                        <Input />
                    </Form.Item>

                    <Form.Item label={t('skin_care.know_from')}>
                        <Input />
                    </Form.Item>

                </div>

            </Form>

            {/* Tình trạng & Nhu cầu */}

            <div className="font-semibold mt-6 mb-3 text-000000e0">
                {t('skin_care.status_needs')}
            </div>

            <Card size="small" className="mb-4">

                <div className="mb-2 text-000000e0">{t('skin_care.skin_status')}</div>

                <Checkbox.Group
                    options={[
                        { label: t('skin_care.skin_oily'), value: "da_dau" },
                        { label: t('skin_care.skin_dry'), value: "da_kho" },
                        { label: t('skin_care.skin_acne'), value: "da_mun" },
                        { label: t('skin_care.skin_combination'), value: "da_hon_hop" },
                    ]}
                    className="grid grid-cols-2 md:grid-cols-4 gap-3"
                />

                <div className="mt-4">
                    <div className="mb-2 text-000000e0">{t('skin_care.improvement_needs')}</div>
                    <Input.TextArea rows={2} />
                </div>

                <div className="mb-2 mt-4 text-000000e0">{t('skin_care.aftercare_channel')}</div>

                <Checkbox.Group
                    options={[
                        { label: t('skin_care.channel_phone'), value: "dien_thoai" },
                        { label: t('skin_care.channel_facebook'), value: "facebook" },
                        { label: t('skin_care.channel_zalo'), value: "zalo" },
                        { label: t('skin_care.channel_other'), value: "khac" },
                    ]}
                    className="grid grid-cols-2 md:grid-cols-4 gap-3"
                />

            </Card>

            {/* Bệnh sử & Sinh hoạt */}

            <div className="font-semibold mb-3 text-000000e0">
                {t('skin_care.history_title')}
            </div>

            <Card size="small">

                <div className="mb-3 text-000000e0">
                    {t('skin_care.q1')}
                </div>

                <Input className="mb-4" />

                <div className="mb-3 text-000000e0">
                    {t('skin_care.q2')}
                </div>

                <Input className="mb-4" />

                <div className="mb-3 text-000000e0">
                    {t('skin_care.q3')}
                </div>

                <Input className="mb-4" />

                <div className="mb-3 text-000000e0">
                    {t('skin_care.q4')}
                </div>

                <Input className="mb-4" />

                <div className="mb-3 font-medium text-000000e0">
                    {t('skin_care.q5')}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">

                    <div className="flex items-center justify-between bg-gray-50 dark:bg-slate-800 px-4 py-3 rounded-lg">
                        <span className="text-gray-800 dark:text-gray-200">
                            {t('skin_care.diet')}
                        </span>

                        <Radio.Group>
                            <Radio value="diet">{t('skin_care.diet_yes')}</Radio>
                            <Radio value="no">{t('skin_care.no')}</Radio>
                        </Radio.Group>
                    </div>


                    <div className="flex items-center justify-between bg-gray-50 dark:bg-slate-800 px-4 py-3 rounded-lg">
                        <span className="text-gray-800 dark:text-gray-200">
                            {t('skin_care.sports')}
                        </span>

                        <Radio.Group>
                            <Radio value="yes">{t('skin_care.yes')}</Radio>
                            <Radio value="no">{t('skin_care.no')}</Radio>
                        </Radio.Group>
                    </div>


                    <div className="flex items-center justify-between bg-gray-50 dark:bg-slate-800 px-4 py-3 rounded-lg">
                        <span className="text-gray-800 dark:text-gray-200">
                            {t('skin_care.smoking')}
                        </span>

                        <Radio.Group>
                            <Radio value="yes">{t('skin_care.yes')}</Radio>
                            <Radio value="no">{t('skin_care.no')}</Radio>
                        </Radio.Group>
                    </div>


                    <div className="flex items-center justify-between bg-gray-50 dark:bg-slate-800 px-4 py-3 rounded-lg">
                        <span className="text-gray-800 dark:text-gray-200">
                            {t('skin_care.insomnia')}
                        </span>

                        <Radio.Group>
                            <Radio value="yes">{t('skin_care.yes')}</Radio>
                            <Radio value="no">{t('skin_care.no')}</Radio>
                        </Radio.Group>
                    </div>


                    <div className="flex items-center justify-between bg-gray-50 dark:bg-slate-800 px-4 py-3 rounded-lg">
                        <span className="text-gray-800 dark:text-gray-200">
                            {t('skin_care.alcohol')}
                        </span>

                        <Radio.Group>
                            <Radio value="yes">{t('skin_care.yes')}</Radio>
                            <Radio value="no">{t('skin_care.no')}</Radio>
                        </Radio.Group>
                    </div>


                    <div className="flex items-center justify-between bg-gray-50 dark:bg-slate-800 px-4 py-3 rounded-lg">
                        <span className="text-gray-800 dark:text-gray-200">
                            {t('skin_care.stress')}
                        </span>

                        <Radio.Group>
                            <Radio value="yes">{t('skin_care.yes')}</Radio>
                            <Radio value="no">{t('skin_care.no')}</Radio>
                        </Radio.Group>
                    </div>

                </div>

            </Card>

            {/* Footer */}

            <div className="flex flex-col sm:flex-row justify-end gap-3 mt-6">

                <Button icon={<Printer size={16} />}>
                    {t('skin_care.print')}
                </Button>

                <Button type="primary" icon={<Save size={16} />}>
                    {t('skin_care.save')}
                </Button>

            </div>

        </Card>
    );
}